import Vue from 'vue';

const SEON_CONFIG = Object.freeze({
  SCRIPT_TYPE: 'application/javascript',
  UPLOAD_ERROR: 'Seon script is not loaded.',
});

const SEON_CDN_URLS = [
  'https://cdn.dfsdk.com/js/v6/agent.umd.js',
  'https://cdn.deviceinf.com/js/v6/agent.umd.js',
  'https://cdn.seonintelligence.com/js/v6/agent.umd.js',
];

class Seon {
  seon = null;

  config = null;

  constructor(ctx) {
    this.ctx = ctx;
  }

  set seon(seonInstance) {
    this.seon = seonInstance;
    seonInstance.init();
  }

  set config(config) {
    this.config = config;
  }

  get session() {
    return this.seon.getSession(this.config);
  }

  initSeon = () => {
    if (window.seon) {
      this.seon = window.seon;
      this.config = {
        geolocation: {
          enabled: true,
          highAccuracy: true,
          canPrompt: true,
        },
        silentMode: true,
      };
    }
  };

  logError(url) {
    if (this.ctx.app.$sentry && this.ctx.app.$sentry.captureException) {
      this.ctx.app.$sentry.captureException(new Error(`${url} ${SEON_CONFIG.UPLOAD_ERROR}`));
    }
  }

  initScript = (attemptCount = 0) => {
    const url = SEON_CDN_URLS[attemptCount];

    if (!url) {
      return this.logError(url);
    }

    const seonScript = document.createElement('script', {});
    seonScript.src = url;
    seonScript.type = SEON_CONFIG.SCRIPT_TYPE;
    seonScript.defer = true;
    seonScript.onload = this.initSeon;
    seonScript.onerror = () => {
      this.logError(url);
      this.initScript(attemptCount + 1);
    };
    document.head.appendChild(seonScript);
  };
}

export default (ctx, inject) => {
  const seon = new Seon(ctx);
  Vue.prototype.$seon = seon;
  inject('seon', seon);
};
